import { action, computed, observable, makeObservable } from 'mobx';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { getConversationItemEvent } from 'nomst/Stores/Decision/Constants/conversationItemEvent';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';

export class ConversationSummary {

    @computed
    get hasNoUnreadMessages(): boolean {
        return !this.unreadMessageCount;
    }

    entityId: string;

    @observable employeeSourceId: string;

    @observable employeeDisplayName: string;

    @observable unreadMessageCount: number;

    @observable hasMessages: boolean;
    private readonly _configuration: Configuration;

    constructor(
        conversationSummaryDto: IConversationSummary,
        employeeSourceId: string,
        employeeDisplayName: string,
        configuration: Configuration) {
        makeObservable(this);
        this.entityId = conversationSummaryDto.entityId;
        this.unreadMessageCount = conversationSummaryDto.unreadMessageCount ?? 0;
        this.hasMessages = conversationSummaryDto.messageCount > 0;
        this.employeeSourceId = employeeSourceId;
        this.employeeDisplayName = employeeDisplayName;
        this._configuration = configuration;
    }

    @action setHasMessages(hasMessages: boolean): void {
        this.hasMessages = hasMessages;
    }

    @action resetUnreadMessageCount(): void {
        this.unreadMessageCount = 0;
    }

    @action async sendConversationItemEvent(): Promise<void> {
        await dataManagerFactory.getEventDataManager().sendConversationItemEvent(
            this._configuration.masterAccountId,
            this.employeeSourceId,
            getConversationItemEvent(this.employeeSourceId, this._configuration.cycleId));
    }
}